<template>
<div>
   <div  id="data-list-thumb-view" class="data-list-container">    
    <vs-table ref="table" 
     pagination 
     :max-items="itemsPerPage" 
     search 
     :data="courseReport">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
      <h2>Courses</h2>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ courseReport.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : courseReport.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Course</vs-th>
        <vs-th>Modules</vs-th>
        <vs-th>Lessons</vs-th>
        <vs-th sort-key="views">Views</vs-th>
        <vs-th sort-key="totalhrs">Total Duration</vs-th>
        <vs-th sort-key="watchhrs">Watched Hours</vs-th>
        <vs-th sort-key="upDate">Updated Date</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
             <!-- <vs-td>
              <p class="sl no.">{{indextr + 1}}</p>
            </vs-td> -->
            <vs-td >
              <p class="reports-name font-medium truncate" >{{tr.title}}</p>
            </vs-td>

            <vs-td>
              <p class="reports-modules">{{ tr.modulesCount }}</p>
            </vs-td>

            <vs-td>
              <p class="reports-chapters">{{ tr.lessonsCount }}</p>
            </vs-td>
            <vs-td>
              <p class="reports-totalhrs">{{ tr.views }}</p>
            </vs-td>
             <vs-td>
              <p class="reports-totalhrs">{{ tr.totalDuration }}</p>
            </vs-td>
             <vs-td>
              <p class="reports-watchhrs">{{ tr.totalWatchedDuration }}</p>
            </vs-td>
             <vs-td>
              <p class="reports-updateDate">{{ new Date(tr.date).toLocaleString() }}</p>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
     <vs-table ref="table" 
     pagination 
     :max-items="itemsPerPage2" 
     search 
     :data="lessonReport">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
      <h2>Lessons</h2>
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage2 - (itemsPerPage2 - 1) }} - {{ lessonReport.length - currentPage * itemsPerPage2 > 0 ? currentPage * itemsPerPage2 : lessonReport.length }} of {{ queriedItems2 }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <!-- <vs-dropdown-item @click="itemsPerPage2=4">
              <span>4</span>
            </vs-dropdown-item> -->
            <vs-dropdown-item @click="itemsPerPage2=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage2=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage2=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Lesson</vs-th>
        <vs-th>Course </vs-th>
        <vs-th>Module </vs-th>
        
        <vs-th sort-key="views">Views</vs-th>
        <vs-th sort-key="totalhrs">Total Duration</vs-th>
        <vs-th sort-key="watchhrs">Watched Duration</vs-th>
        <vs-th sort-key="upDate">Updated Date</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
             <!-- <vs-td>
              <p class="sl no.">{{indextr + 1}}</p>
            </vs-td> -->

            <vs-td>
              <p class="reports-chapters font-medium ">{{ tr.lesson.lessonTitle }}</p>
            </vs-td>

            <vs-td >
              <p class="reports-name " >{{tr.courseTitle}}</p>
            </vs-td>

            <vs-td >
              <p class="reports-name" >{{tr.lesson.module}}</p>
            </vs-td>

            
            <vs-td>
              <p class="reports-chapters">{{ tr.lesson.views }}</p>
            </vs-td>
             <vs-td>
              <p class="reports-totalhrs">{{ tr.lesson.derivedDuration }}</p>
            </vs-td>
             <vs-td>
              <p class="reports-watchhrs">{{ tr.lesson.watchedHours }}</p>
            </vs-td>
             <vs-td>
              <p class="reports-updateDate">{{ new Date(tr.lesson.date).toLocaleString() }}</p>
            </vs-td>

          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
 </div>
</template>

<script>
import moduleCoursesreport from '@/store/coursesReport/moduleCoursesreport.js'
export default {
  components: {

  },
  data () {
    return {
      selected: [],
      itemsPerPage: 4,
      isMounted: false,
      itemsPerPage2:10
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    courseReport () {
      return this.$store.state.coursesReport.courseReport
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.courseReport.length
    },
    lessonReport () {
      return this.$store.state.coursesReport.lessonReport
    },
    queriedItems2 () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.lessonReport.length
    }
  },
  methods: {

  },
  created () {
    if (!moduleCoursesreport.isRegistered) {
      this.$store.registerModule('coursesReport', moduleCoursesreport)
      moduleCoursesreport.isRegistered = true
    }
    this.$store.dispatch('coursesReport/fetchCourseReport')
    this.$store.dispatch('coursesReport/fetchLessonReport')
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
